import { ServiceCaller } from './services/ServiceCaller'

export class BasePage {
    
    api: ServiceCaller;

    constructor(private serviceCaller: ServiceCaller) {
        this.api = serviceCaller;
    }

}


// WEBPACK FOOTER //
// D:/Works/Safetyminder/Safetyminder/Admin/src/app/shared/base.page.ts